export const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY;
export const apiBaseUrl = process.env.NEXT_PUBLIC_APIBASEURL;
export const oktaTokenEndpoint = "/oauth/token";
export const PLP_END_POINT_SUBSCRIPTION_KEY = "/lw/plp";
export const SSR_PLP_FL = [
  "Color.SKU.Details_ss",
  "productHeading_s",
  "Color.GST.Details_ss",
  "discountedPriceStartingAt.GST_d",
  "displayPriceStartingAt_s",
  "masterSKU_s",
  "priceList.GST.discountedPrice_d",
  "priceList.GST.finalPrice_d",
  "priceList.GST.price_d",
  "priceList.GST.saleOffer_s",
  "priceStartingAt.GST_d",
  "ProductLocalCategory_s",
  "ProductCategory_s",
  "ProductBrandName_s",
  "ProductBrandNameDisplay_s",
  "ProductDescriptionProductShort_s",
  "ProductExclusive_s",
  "productImages.labelWithUrl_ss",
  "productImageVariantImages.labelWithUrl_ss",
  "ProductProductNo_s,RegionBrandName_s",
  "RegionReleaseforShipment_dt",
  "sku_s,SKUColorFinishName_ss",
  "SKUColorSwatchFilename_ss",
  "slug_s",
  "variantList.sku_ss",
  "id",
  "sku_s",
  "productImages.url_s",
  "productImages.url_ss",
  "RegionBrandName_ss",
  "productName_s",
  "ProductHandleStyleType_s",
  "ProductNumberofHandles_s",
  "ProductNumberofHoles_s",
  "ProductWaterSense_s",
  "ProductBowlShape_s",
  "ProductBowlStyle_s",
  "ProductConfiguration_s",
  "ProductFeaturesFilter_ss",
  "ProductFlushingSystem_s",
  "ProductHandleStyle_s",
  "ProductLitersPerFlush_s",
  "ProductMinimumRoughInMM_s",
  "ProductOverallLengthMm_s",
  "ProductPriceSegment_s",
  "ProductProductType_s",
  "ProductShape_s",
  "ProductStyle_ss",
  "ProductTrapwayType_s",
  "CustomerFacingSKU_s",
  "productImage.url_ss",
];
export const EXCEPTIONAL_SITENAME = "thailand";
export const authorBaseUrl = process.env.NEXT_PUBLIC_BASEURL;
export const SWATCH_NA = "swatch_NA";
export const PLP_END_POINT_CLIENT = "/search/v1/plp";
export const LUCIDWORKS_PLP_URL =
  "https://kohler-dev.b.lucidworks.cloud/api/apps/thailand/query/profile_thailand_PLP";

export const FILTERS_FL = [
  "Color.SKU.Details_ss",
  "discountedPriceStartingAt.GST_d",
  "displayPriceStartingAt_s",
  "masterSKU_s",
  "priceList.GST.discountedPrice_d",
  "priceList.GST.finalPrice_d",
  "priceList.GST.price_d",
  "priceList.GST.saleOffer_s",
  "priceStartingAt.GST_d",
  "ProductLocalCategory_s",
  "ProductCategory_s",
  "ProductBrandName_s",
  "ProductBrandNameDisplay_s",
  "ProductDescriptionProductShort_s",
  "ProductExclusive_s",
  "productImages.labelWithUrl_ss",
  "productImageVariantImages.labelWithUrl_ss",
  "ProductProductNo_s",
  "RegionBrandName_s",
  "RegionReleaseforShipment_dt",
  "sku_s",
  "SKUColorFinishName_ss",
  "SKUColorSwatchFilename_ss",
  "slug_s",
  "variantList.sku_ss",
];

export const ALLOWED_PRICE_FACET = "priceList.GST.finalPrice_d";
export const siteName = "thailand";
export const lwAppName = "thailand";
export const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/";

export const SEARCH_PDP_FL = [
  "id",
  "sku_s",
  "slug_s",
  "productHeading_s",
  "masterSKU_s",
  "CustomerFacingSKU_s",
  "ProductLocalCategory_s",
  "ProductCategory_s",
  "ProductServices_ss",
  "SKUIsProjectPack_s",
  "ProductBrandNameDisplay_s",
  "Color.SKU.Details_ss",
  "productName_s",
  "RegionBrandName_s",
  "variantList.sku_ss",
  "ProductYoutubeID_s",
  "productImages.labelWithUrl_ss",
  "ProductDescriptionProductShort_s",
  "ProductBrandName_s",
  "ProductOverallLengthInches_s",
  "ProductOverallWidthInches_s",
  "ProductOverallHeightInches_s",
  "ProductWebFeatures_ss",
  "ProductFreightPolicyType_s",
  "RegionReleaseforShipment_dt",
  "ProductBadgeInfo_ss",
  "ProductWebTechnology_ss",
  "ProductNarrativeDescription_s",
  "ProductWebMaterial_ss",
  "ProductWebInstallation_ss",
  "ProductCaliforniaProp65WarningDisclaimer_s",
  "ProductWebRebates_ss",
  "ProductResource.DXFPlanView.resourceFullWebURL_ss",
  "ProductResource.DWGPlanView.resourceFullWebURL_ss",
  "ProductResource.DXFFrontView.resourceFullWebURL_ss",
  "ProductResource.DWGFrontView.resourceFullWebURL_ss",
  "ProductResource.DXFSideView.resourceFullWebURL_ss",
  "ProductResource.DWGSideView.resourceFullWebURL_ss",
  "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
  "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
  "ProductResource.3DRevit.resourceFullWebURL_ss",
  "ProductResource.3D3DS.resourceFullWebURL_ss",
  "ProductResource.3DSketchup.resourceFullWebURL_ss",
  "ProductResource.3DOBJ.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceTitle_ss",
  "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
  "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
  "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
  "SKUDiscontinuedDate_dt",
  "ProductResource.YouTubeInstallVideo.resourceName_ss",
  "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
  "ProductResource.InteractiveSVG.resourceName_ss",
  "ProductResource.InteractiveSVG.resourceTitle_ss",
  "ProductProductNo_s",
  "productImages.url_ss",
  "ProductDescriptionProduct_s",
  "pageDescription_s",
  "pageTitle_s",
  "canonicalUrl_s",
  "id",
  "keywords_s",
  "buFilter_s",
  "indexedTime_s",
  "pageType_s",
  "ProductHandleStyleType_s",
  "ProductNumberofHandles_s",
  "ProductNumberofHoles_s",
  "ProductWaterSense_s",
  "ProductBowlShape_s",
  "ProductBowlStyle_s",
  "ProductConfiguration_s",
  "ProductFeaturesFilter_ss",
  "ProductFlushingSystem_s",
  "ProductHandleStyle_s",
  "ProductLitersPerFlush_s",
  "ProductMinimumRoughInMM_s",
  "ProductOverallLengthMm_s",
  "ProductPriceSegment_s",
  "ProductProductType_s",
  "ProductShape_s",
  "ProductStyle_ss",
  "ProductTrapwayType_s",
  "ProductMaterial_s",
  "RegionBrandName_ss",
  "Color.GST.Details_ss",
  "masterCustomerFacingSKU_s",
  "spec_s",
  "productImage.url_ss",
];
export const searchPdpEndPoint = "/search/pdp";

export const structuredPLPProfileName = (tag = "Toilets") =>
  `profile_${lwAppName}_PLP_${tag}`;

export const searchPLPEndPoint = "/search/plp";

export const masterPLPFL = [
  "Color.SKU.Details_ss",
  "productHeading_s",
  "Color.GST.Details_ss",
  "masterSKU_s",
  "priceList.GST.finalPrice_d",
  "ProductBrandNameDisplay_s",
  "productImages.labelWithUrl_ss",
  "ProductLocalCategory_s",
  "ProductNarrativeDescription_s",
  "ProductCategory_s",
  "ProductTechnicalHeader*_s",
  "ProductTechnicalHeader*Bullet_ss",
  "sku_s",
  "slug_s",
  "variantList.sku_ss",
  "priceList.GST.discountedPrice_d",
  "priceList.GST.finalPrice_d",
  "priceList.GST.price_d",
  "priceList.GST.saleOffer_s",
  "priceStartingAt.GST_d",
  "ProductBrandName_s",
  "ProductDescriptionProductShort_s",
  "productImages.url_s",
  "productImages.url_ss",
  "sku_s,SKUColorFinishName_ss",
  "SKUColorSwatchFilename_ss",
  "masterCustomerFacingSKU_s",
  "RegionBrandName_ss",
  "productName_s",
  "CustomerFacingSKU_s",
  "productImage.url_ss",
];

export const APIM_BASE_URL = `${process.env.NEXT_PUBLIC_BASEURL}/apirequest`;
export const searchSuggestionFL = [
  "sku_s",
  "slug_s",
  "url_s",
  "variantList.sku_ss",
  "ProductCategory_s",
];

export const BRAND_REGISTRATION_SUBMIT_API = `${APIM_BASE_URL}/crm/brand/registration?channel=apac`;
export const CONTACT_NOTIFICATION_FORM_SUBMIT_API = `${APIM_BASE_URL}/notification/form?type=internal&channel=apac`;

export const DEFAULT_VISIBLE_FILTERS = 4; // Show 5 filter accordions by default

export const COMPARE_ERRORS = {
  en: "Only three comparison products are allowed. Please remove one in order to allow adding this new compare to the list.",
  th: "อนุญาตให้เปรียบเทียบผลิตภัณฑ์ได้เพียงสามรายการเท่านั้น โปรดลบรายการหนึ่งเพื่อให้สามารถเพิ่มรายการเปรียบเทียบใหม่ได้",
};

export const PDP_FL_payload = {
  q: "*:*",
  fl: "id,sku_s,slug_s,Color.GST.Details_ss,masterSKU_s,CustomerFacingSKU_s,ProductLocalCategory_s,ProductServices_ss,ProductBrandNameDisplay_s,Color.SKU.Details_ss,productName_s,RegionBrandName_s,variantList.sku_ss,productImages.labelWithUrl_ss,ProductDescriptionProductShort_s,productRegionAllVariantDiscontinued_b,ProductBrandName_s,ProductOverallLengthInches_s,ProductOverallWidthInches_s,ProductOverallHeightInches_s,ProductWebFeatures_ss,ProductBadgeInfo_ss,ProductWebTechnology_ss,ProductNarrativeDescription_s,ProductWebMaterial_ss,ProductWebInstallation_ss,ProductResource.DXFPlanView.resourceFullWebURL_ss,ProductResource.DWGPlanView.resourceFullWebURL_ss,ProductResource.DXFFrontView.resourceFullWebURL_ss,ProductResource.PartsPDFFileName.resourceName_ss,ProductResource.DWGFrontView.resourceFullWebURL_ss,ProductResource.DXFSideView.resourceFullWebURL_ss,ProductResource.DWGSideView.resourceFullWebURL_ss,ProductResource.3DDXFSymbol.resourceFullWebURL_ss,ProductResource.3DRevit.resourceFullWebURL_ss,ProductResource.3D3DS.resourceFullWebURL_ss,ProductResource.3DSketchup.resourceFullWebURL_ss,ProductResource.3DOBJ.resourceFullWebURL_ss,ProductResource.CutOutDXF.resourceFullWebURL_ss,ProductResource.SpecPDFFileName.resourceName_ss,ProductResource.SpecPDFFileName.resourceFullWebURL_ss,ProductResource.EnvironProdDecl.resourceFullWebURL_ss,ProductResource.EnvironProdDecl.resourceTitle_ss,ProductResource.HomeownersGuide.resourceFullWebURL_ss,ProductResource.HomeownersGuide.resourceTitle_ss,ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss,ProductResource.PartsPDFFileName.resourceFullWebURL_ss,ProductResource.InstallationWithoutSPPDF.resourceTitle_ss,SKUDiscontinuedDate_dt,ProductResource.YouTubeInstallVideo.resourceName_ss,ProductResource.InteractiveSVG.resourceTitle_ss,ProductProductNo_s,ProductOverallHeightMm_i,ProductOverallWidthMm_i,title_s,ItemResource.IMGSpinSet.resourceFullWebURL_ss,ItemResource.IMGSpinSet.resourceName_ss,ItemResource.IMGSpinSet.resourceAltText_ss,ItemResource.IMGSpinSet.resourceType_ss,productLocalCategoryBreadCrumb_s,productImages.url_ss,ProductDescriptionProduct_s,pageDescription_s,pageTitle_s,canonicalUrl_s,keywords_s,pageType_s,RegionBrandName_ss, ProductInstallationType_ss,ProductResource,ProductMaterial_s,ProductCategory_s,ProductSection_ss,ProductHandleStyleType_s,ProductNumberofHandles_s,ProductNumberofHoles_s,ProductWaterSense_s,ProductBowlShape_s,ProductBowlStyle_s,ProductConfiguration_s,ProductFeaturesFilter_ss,ProductFlushingSystem_s,ProductHandleStyle_s,ProductLitersPerFlush_s,ProductMinimumRoughInMM_s,ProductOverallLengthMm_s,ProductPriceSegment_s,ProductProductType_s,ProductShape_s,ProductStyle_ss,ProductTrapwayType_s,productDiscontinued_b,ProductResource.GIFLineArt.resourceAltText_ss,ProductResource.GIFLineArt.resourceFullWebURL_ss, RegionRetailer1URL_ss, RegionRetailer1IMG_ss, RegionRetailer4URL_ss",
  collections: "thailand",
  profilename: "profile_thailand_PDP",
  // fq: "language_s:en",
};

export const COMPARE_PRODUCTS_DIFF_CATEGORY_ERROR = {
  en: "You can only compare products from the same category. Adding this product will clear your current comparison.",
  th: "คุณสามารถเปรียบเทียบผลิตภัณฑ์จากหมวดหมู่เดียวกันได้เท่านั้น การเพิ่มผลิตภัณฑ์นี้จะล้างการเปรียบเทียบปัจจุบันของคุณ",
};

export const PLP_PATTERN = /\/browse\/[^/]+\/Categories/i;
export const SEARCH_PATTERN = /^\/results\?/i;

export const SLICK_CAROUSEL_PRODUCT_HEADING = {
  en: "VIEW FEATURED PRODUCTS",
  th: "ดูผลิตภัณฑ์เด่น",
};

export const SearchResultPageTitle = {
  en: "Search Results | Kohler",
  th: "ผลการค้นหา | Kohler",
};

export const printFooterText = {
  questionsText: {
    en: "Have Questions? Visit Us at",
    th: "มีคำมี คำ ถาม? เยี่ยยี่ มชมเราที่",
  },
  copyrightText: {
    en: "*Due to the differences in monitors, technical factors, and characteristics of some of our finishes, the colors shown here cannot be represented with all their true qualities. The color titles should only be considered a guide",
    th: "* เนื่องจากความแตกต่างในจอภาพปัจจัยจั ทางเทคนิคและลักษณะของการตกแต่งของเราสีที่สี ที่แสดงในที่นี้ไม่สม่ ามารถแสดงด้วยคุณคุ สมบัติบั ติที่แท้ จริงริทั้งทั้ หมดของพวกเขา . ชื่อชื่สีคสี วรได้รัด้บรัการพิจพิารณาให้เห้ป็นคู่มืคู่ อมืเท่านั้น",
  },
};

export const SEARCH_RESTRICT_PATTERN = /[^a-zA-Z0-9 '"-]/g;

export const MENU_LOCALE_TEXT = {
  en: "en",
  th: "ไทย",
};
export const kohlerHeaders = [
  MENU_LOCALE_TEXT.en,
  MENU_LOCALE_TEXT.th,
  "kohler company",
  "บริษัท โคห์เลอร์",
];
